module.exports = __webpack_public_path__ + "img/standard-viewer-mini.98088773.svg";